import { combineReducers } from 'redux';

import settingsReducer, { ISettingsState } from './settings/settings.reducer';
import filtersReducer, { IFiltersState } from './filters/filters.reducer';
import productsReducer, { IProductsState } from './products/products.reducer';
import tagsReducer, { ITagsState } from './tags/tags.reducer';

export interface IMarketplaceState {
  settings: ISettingsState;
  filters: IFiltersState;
  products: IProductsState;
  tags: ITagsState;
}

const reducer = combineReducers({
  settings: settingsReducer,
  filters: filtersReducer,
  products: productsReducer,
  tags: tagsReducer,
});

export default reducer;
